import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";

const getTodaysDate = () => {
 const today = new Date();
 const year = today.getFullYear();
 const month = String(today.getMonth() + 1).padStart(2, "0");
 const day = String(today.getDate()).padStart(2, "0");

 return `${day}-${month}-${year}`;
};

const getFormattedDateTime = () => {
 const currentDateTime = new Date();

 // Extract date components
 const day = String(currentDateTime.getDate()).padStart(2, "0"); // Get day and add leading zero if necessary
 const month = String(currentDateTime.getMonth() + 1).padStart(2, "0"); // Get month and add leading zero if necessary
 const year = currentDateTime.getFullYear(); // Get year

 // Extract time components
 const hours = String(currentDateTime.getHours()).padStart(2, "0"); // Get hours
 const minutes = String(currentDateTime.getMinutes()).padStart(2, "0"); // Get minutes
 const seconds = String(currentDateTime.getSeconds()).padStart(2, "0"); // Get seconds

 // Format date and time as dd-mm-yyyy hh:mm:ss
 const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
 return formattedDateTime;
};

export const ApproverSlice = createSlice({
 name: "approver",
 initialState: {
  error: false,
  launchMails: [],
  userLaunchMails: [],
  currentStatus: "",
  isStatusSubmission: null,
  isReviewStarted: false,
  isIdNull: false,
 },
 reducers: {
  setTemplateData: (state, { payload }) => {
   state.launchMails = payload;
  },
  setUserTemplateData: (state, { payload }) => {
   state.userLaunchMails = payload;
  },
  setApprovedData: (state, { payload }) => {
   state.launchMails.map((val, i) => {
    if (val.uniqueID == payload.uniqueID) {
     val.isApproved = payload.status;
     val.approvedDate= getTodaysDate();
     val.approveddatetime= getFormattedDateTime();
     val.fileStatus="Un-assigned";
     val.approvedby = payload.approver;
    }
   });
  },
  setAssigned: (state,{payload}) => {
    const target = state.launchMails.find(val => val.uniqueID === payload.uniqueID);
    if (target) {
      target.fileStatus = payload.fileStatus;
      target.assignedTo = payload.assignedTo;
      target.assignedBy = payload.assignedBy;
    }
  },
  updateLauchMails: (state, { payload }) => {
   state.launchMails.map((val, i) => {
    if (val.uniqueID == payload.values.uniqueID) {
     val.template = payload.values.template;
    }
   });
  },
  updateMailerDetails: (state, {payload} ) => {
     
    state.launchMails.map((val, i) => {
     if (val.uniqueID == payload.uniqueID) {
      val.programname = payload.newname;
     }
    });
    alert(`Successfully changed program name to "${payload.newname}".`)
   },

  setCurrentStatus: (state, { payload }) => {
   state.currentStatus = payload.status;
   state.isStatusSubmission = true;
  },
  setIsStatusUpdated: (state, { payload }) => {
   state.isStatusSubmission = payload;
  },
  setReviewUpdation: (state, { payload }) => {
   state.isReviewStarted = payload;
  },
  setValidation: (state, { payload }) => {
   state.isIdNull = payload;
  },

  setError: (state) => {
   state.error = true;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setTemplateData,
 setApprovedData,
 setAssigned,
 updateLauchMails,
 updateMailerDetails,
 setUserTemplateData,
 setCurrentStatus,
 setIsStatusUpdated,
 setReviewUpdation,
 setValidation,
} = ApproverSlice.actions;

export default ApproverSlice.reducer;

export function fetchLauchMailresponse() {
 return (dispatch) => {
  axios
   .get(`${baseURL}/fetchLauchMails`)
   .then((response) => {
    dispatch(setTemplateData(response.data));

    // then print response status
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    dispatch(setError(err));
   });
 };
}

export const updateProgramNameInMailer=createAsyncThunk(
  "approver/updateprogramname",
  async(payload,thunkAPI)=>{
    try{
      const response= await axios.put(`${baseURL}/mailerdetails`,payload);
      thunkAPI.dispatch(updateMailerDetails(payload));
    }catch(err){
      console.error("update fail", err);
      thunkAPI.dispatch(setError(err));
    }
  }
)

export function fetchUserLauchMailresponse(user) {
 return (dispatch) => {
  axios
   .get(`${baseURL}/fetchUserLauchMails/${user}`)
   .then((response) => {
    dispatch(setUserTemplateData(response.data));

    // then print response status
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    dispatch(setError(err));
   });
 };
}


export function handleDataApprpval(detail) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/updateStatus`, { detail },{
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        })
   .then((response) => {
    dispatch(setApprovedData(detail));
    dispatch(setCurrentStatus(detail));
    dispatch(setIsStatusUpdated(true));
   })
   .catch((err) => {
    console.error("update status fail", err);
    dispatch(setIsStatusUpdated(false));
   });
 };
}
export function handleApproverUpdatedContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/saveTemplate`, { values })
   .then((response) => {
    dispatch(updateLauchMails({ values }));
    dispatch(setIsStatusUpdated(true));
   })
   .catch((err) => {
    console.error("upload fail", err);
    dispatch(updateLauchMails());
    dispatch(setIsStatusUpdated(false));
   });
 };
}
export function updateCurrentStatus(status) {
 return (dispatch) => {
  console.log("insetCurrentStatus", status);
  dispatch(setCurrentStatus(status));
 };
}
export function updateStartReviewTime(id,onBehalf) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/updateStartReviewTime`, { id ,onBehalf})
   .then((response) => {
    dispatch(setReviewUpdation(true));
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    dispatch(setError(err));
   });
 };
}
export function fetchStartReviewTime(id) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/fetchStartReviewTime`, { id })
   .then((response) => {
    console.log("response.darta", response.data[0].reviewstartdatetime);
    if (response.data[0].reviewstartdatetime != null) {
     dispatch(setReviewUpdation(true));
    } else {
     dispatch(setReviewUpdation(false));
    }

    // then print response status
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    dispatch(setError(err));
   });
 };
}

export function handleIdValidation(val) {
 return (dispatch) => {
  dispatch(setValidation(val));
 };
}
